import { render } from "./ManagerCard.vue?vue&type=template&id=4ae48fc2"
import script from "./ManagerCard.vue?vue&type=script&lang=js"
export * from "./ManagerCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__